import React, { useState, useEffect } from 'react';
import { getDistances, registerSwimmer } from '../api';
import DistanceCheckbox from './DistanceCheckbox';
import './RegistrationForm.css';
import clubsData from '../data/clubs.json';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RegistrationForm = () => {
    const [distances, setDistances] = useState([]);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        birthDate: '',
        gender: '',
        email: '',
        phone: '',
        club: '',
        city: '',
        selectedDistances: [],
        consent: false
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [submissionData, setSubmissionData] = useState(null);
    const navigate = useNavigate();

    // Загрузка клубов из JSON
    /*useEffect(() => {
        setClubs(clubsData);
    }, []);*/

    // Фильтрация клубов по поисковому запросу
    /*const filteredClubs = clubsData.filter(club =>
        club.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        club.city.toLowerCase().includes(searchTerm.toLowerCase())
    );*/

    // Загрузка дистанций при изменении пола
    useEffect(() => {
        if (formData.gender) {
            const loadDistances = async () => {
                try {
                    const response = await getDistances(formData.gender);
                    setDistances(response.data);
                } catch (error) {
                    console.error('Error loading distances:', error);
                }
            };
            loadDistances();
        }
    }, [formData.gender]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleDistanceToggle = (distanceId) => {
        setFormData(prev => {
            const isSelected = prev.selectedDistances.some(d => d.id === distanceId);

            if (isSelected) {
                return {
                    ...prev,
                    selectedDistances: prev.selectedDistances.filter(d => d.id !== distanceId)
                };
            } else {
                if (prev.selectedDistances.length >= 4) {
                    toast.error('Можно выбрать не более 4 дистанций');
                    //alert('Можно выбрать не более 4 дистанций');
                    return prev;
                }

                const distance = distances.find(d => d.id === distanceId);
                return {
                    ...prev,
                    selectedDistances: [
                        ...prev.selectedDistances,
                        { id: distanceId, entry_time: '', price: distance.price }
                    ]
                };
            }
        });
    };

    const handleTimeChange = (distanceId, time) => {
        setFormData(prev => ({
            ...prev,
            selectedDistances: prev.selectedDistances.map(d =>
                d.id === distanceId ? { ...d, entry_time: time } : d
            )
        }));
    };

    const calculateTotal = () => {
        console.log(formData.selectedDistances.length);
        let countDistance = formData.selectedDistances.length;
        let total = 0;
        if(countDistance == 1) {
            total = 1200;
        }
        if(countDistance == 2) {
            total = 2000;
        }
        if(countDistance == 3) {
            total = 2600;
        }
        if(countDistance == 4) {
            total = 3000;
        }
        //return formData.selectedDistances.reduce((sum, d) => sum + d.price, 0);
        return total;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

       /* const selectedClub = clubsData.find(club => club.name === Number(formData.clubname));
console.log(formData);
        if (formData.selectedDistances.length === 0) {
            alert('Выберите хотя бы одну дистанцию');
            return;
        }*/

        try {
            const payload = {
                ...formData,
                //club: selectedClub,
                distances: formData.selectedDistances.map(d => ({
                    id: d.id,
                    entry_time: d.entry_time
                }))
            };

            const response = await registerSwimmer(payload);

            setSubmissionData({
                name: `${formData.firstName} ${formData.lastName}`,
                //club: selectedClub.name,
                distances: formData.selectedDistances.map(d => {
                    const distance = distances.find(dist => dist.id === d.id);
                    return `${distance.meters}m ${distance.style} - ${d.entry_time}`;
                }),
                //totalAmount
            });


            //setIsSubmitted(true);

            navigate(`/registration/${response.data.code}`);
            //alert(`Успешная регистрация! Сумма к оплате: ${response.data.total_amount} руб. ${response.data.code}`);

            // Сброс формы
            setFormData({
                firstName: '',
                lastName: '',
                birthDate: '',
                gender: '',
                email: '',
                phone: '',
                club: '',
                city: '',
                selectedDistances: [],
                consent: false
            });

        } catch (error) {
            toast.error(error.response?.data?.message || 'Ошибка при регистрации', { position: "bottom-center" });
            //alert(error.response?.data?.message || 'Ошибка при регистрации');
        }
    };
    if (isSubmitted) {
        return (
            <div className="registration-container">
                <div className="success-message">
                    <h2 className="success-title">Регистрация успешно завершена!</h2>

                    <div className="success-details">
                        <h3>Ваши данные:</h3>
                        <p><strong>Участник:</strong> {submissionData.name}</p>
                        <p><strong>Клуб:</strong> {submissionData.club}</p>

                        <div className="distances-list">
                            <h4>Зарегистрированные дистанции:</h4>
                            <ul>
                                {submissionData.distances.map((distance, index) => (
                                    <li key={index}>{distance}</li>
                                ))}
                            </ul>
                        </div>

                        <p className="total-amount">
                            <strong>Сумма к оплате:</strong> {submissionData.totalAmount} руб.
                        </p>
                    </div>

                    {/*<button*/}
                    {/*    onClick={handleNewRegistration}*/}
                    {/*    className="new-registration-button"*/}
                    {/*>*/}
                    {/*    Зарегистрировать нового участника*/}
                    {/*</button>*/}
                </div>
            </div>
        );
    }
    return (
        <div className="registration-container">


            <h3 className="registration-title">Регистрация на IX открытый турнир по плаванию
                завершена</h3>
            <a href="https://reg.swimsport.ru/Ладья_final.pdf" target="_blank">Стартовый протокол</a>
            <small>
                <p>Посмотреть положение и сроки: <a href="https://reg.swimsport.ru/rules.pdf" target={'_blank'}>Положение</a></p>
                <p>Соревнования проводятся  27-28  июня 2026 г. в г. Тольятти, бассейн УСК "Олимп"
                    (50 метров, 8 дорожек, хронометраж полуэлектронный) по адресу: Самарская обл.,
                    г.Тольятти, Автозаводский район, Приморский бульвар, 49. </p>
                <p>Комиссия по допуску:   27 июня   12.00-13.00  в холле УСК «Олимп». </p>
                <p>Начало соревнований:   27 июня - 14-00,  разминка в 13-00 час. </p>
                <p>28 июня - 11-00,  разминка в 10-00 час.</p>
            </small>
        </div>
    );
    return (
        <div className="registration-container">

            <small>
            <p>Посмотреть положение и сроки: <a href="https://reg.swimsport.ru/rules.pdf" target={'_blank'}>Положение</a></p>
            <p>Соревнования проводятся  27-28  июня 2026 г. в г. Тольятти, бассейн УСК "Олимп"
                (50 метров, 8 дорожек, хронометраж полуэлектронный) по адресу: Самарская обл.,
                г.Тольятти, Автозаводский район, Приморский бульвар, 49. </p>
            <p>Комиссия по допуску:   27 июня   12.00-13.00  в холле УСК «Олимп». </p>
            <p>Начало соревнований:   27 июня - 14-00,  разминка в 13-00 час. </p>
            <p>28 июня - 11-00,  разминка в 10-00 час.</p>
            </small>
            <h3 className="registration-title">Регистрация на IX открытый турнир по плаванию
                в категории Мастерс «ЛАДЬЯ - 2026» Тольятти</h3>
            <form onSubmit={handleSubmit} className="registration-form">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                     <div className="form-group">
                        <label className="form-label">Фамилия*</label>
                        <input
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Имя*</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Дата рождения*</label>
                        <input
                            type="date"
                            name="birthDate"
                            value={formData.birthDate}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Пол*</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        >
                            <option value="">Выберите пол</option>
                            <option value="Male">Мужской</option>
                            <option value="Female">Женский</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Спортивное звание</label>
                        <select
                            name="gender"
                            // value={formData.gender}
                            // onChange={handleInputChange}
                            className="form-input"
                        >
                            <option value="">Выбрать</option>
                            <option value="КМС-М">КМС-М</option>
                            <option value="МС-М">МС-М</option>
                            <option value="МСМК-М">МСМК-М</option>
                            <option value="КМС">КМС</option>
                            <option value="МС">МС</option>
                            <option value="МСМК">МСМК</option>
                        </select>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="form-group">
                    <label className="form-label">Email*</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Телефон</label>
                    <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="form-input"
                    />
                </div>

                <div className="form-group">

                        <label className="block text-sm font-medium text-gray-700 mb-1">Клуб</label>
                        <select
                            name="club"
                            value={formData.clubname}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        >
                            <option value="Лично (без клуба)">Выберите клуб</option>
                            <option value="Лично (без клуба)">Лично (без клуба)</option>
                            {clubsData.map(club => (
                                <option key={club.id} value={club.name}>
                                    {club.name} ({club.city}){club.coach ? ` - ${club.coach}` : ''}
                                </option>
                            ))}
                        </select>

                    {/*<label className="form-label">Клуб/Команда*</label>*/}
                    {/*<input*/}
                    {/*    type="text"*/}
                    {/*    name="club"*/}
                    {/*    value={formData.club}*/}
                    {/*    onChange={handleInputChange}*/}
                    {/*    className="form-input"*/}
                    {/*    required*/}
                    {/*/>*/}
                </div>

                <div className="form-group">
                    <label className="form-label">Город*</label>
                    <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                    />
                </div>
                </div>
                <div className="form-group">
                    <h3 className="text-lg font-medium mb-3">Выберите дистанции (максимум 4)*</h3>

                    {distances.length === 0 && formData.gender && (
                        <p className="text-gray-500">Загрузка доступных дистанций...</p>
                    )}

                    <div className="distance-grid">
                        {distances.map(distance => (
                            <DistanceCheckbox
                                key={distance.id}
                                distance={distance}
                                checked={formData.selectedDistances.some(d => d.id === distance.id)}
                                onToggle={handleDistanceToggle}
                                entryTime={
                                    formData.selectedDistances.find(d => d.id === distance.id)?.entry_time || ''
                                }
                                onTimeChange={(time) => handleTimeChange(distance.id, time)}
                            />
                        ))}
                    </div>

                    <div className="mt-4 p-3 bg-gray-50 rounded-md">
                        {/*<p className="text-lg font-medium">*/}
                        {/*    Итого к оплате: <span className="text-blue-600">{calculateTotal()} руб.</span>*/}
                        {/*</p>*/}
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.selectedDistances.length} из 4 возможных дистанций
                        </p>
                    </div>
                </div>


                <div className="form-group">
                    <div className="flex items-center mb-2">

                        <input
                            type="checkbox"
                            name="consent"
                            checked={formData.consent}
                            onChange={handleInputChange}
                            className="form-input"
                            required
                        />
                        <span className="ml-2 font-medium">
                            Я даю согласие на обработку персональных данных*
                        </span>

                    </div>
                </div>

                <button
                    type="submit"
                    className="submit-button"
                >
                    Зарегистрироваться
                </button>
            </form>
            <ToastContainer />
        </div>
    );
};

export default RegistrationForm;
